var map = {
	"./01.png": 4150,
	"./404.png": 2359,
	"./about1.jpg": 2036,
	"./aid1.jpg": 5885,
	"./apport1.jpg": 7386,
	"./apport2.jpg": 313,
	"./award-1.png": 5303,
	"./award-2.png": 1453,
	"./award-3.png": 3038,
	"./award-4.png": 535,
	"./award-5.png": 2193,
	"./banner-2.jpg": 403,
	"./banner1-green-blue.jpg": 3532,
	"./banner1-green.jpg": 9745,
	"./banner1.jpg": 2464,
	"./banner2.jpg": 2523,
	"./blog-1.jpg": 7408,
	"./blog-2.jpg": 6014,
	"./blog-3.jpg": 4578,
	"./blog-4.jpg": 8210,
	"./blog-5.jpg": 295,
	"./blog-6.jpg": 6772,
	"./blog-icon-1.png": 2697,
	"./blog-icon-2.png": 3618,
	"./blog-popular-1.jpg": 266,
	"./blog-popular-2.jpg": 2814,
	"./blog-popular-3.jpg": 5,
	"./blog-popular-4.jpg": 9421,
	"./blog/comment/blog-comment-1.png": 6985,
	"./blog/comment/blog-comment-2.png": 755,
	"./book.png": 4004,
	"./buycart/buycart-1.jpg": 5827,
	"./buycart/buycart-2.jpg": 6204,
	"./cart/01.jpg": 5093,
	"./cart/02.jpg": 9340,
	"./cart/03.jpg": 2692,
	"./cart/04.jpg": 8679,
	"./cart/05.jpg": 9646,
	"./cart/cart-1.png": 7546,
	"./certificate-1.jpg": 8724,
	"./certificate-12.jpg": 8217,
	"./certificate-2.jpg": 8261,
	"./certificate-3.jpg": 6298,
	"./certificate-4.jpg": 4513,
	"./certificate-bg.jpg": 8178,
	"./certificate.jpg": 8818,
	"./contact.jpg": 4095,
	"./counter-1.png": 1784,
	"./counter-2.png": 956,
	"./counter-3.png": 642,
	"./counter-4.png": 5077,
	"./counter-5.png": 8350,
	"./counter-6.png": 7017,
	"./counter-7.png": 6280,
	"./credits-1.png": 77,
	"./credits-2.png": 3646,
	"./credits-3.png": 2097,
	"./credits-4.png": 5241,
	"./credits-5.png": 6431,
	"./credits-6.png": 4942,
	"./credits-7.png": 5978,
	"./credits-8.png": 7803,
	"./depart-1.jpg": 8034,
	"./depart-10.jpg": 5728,
	"./depart-2.jpg": 5232,
	"./depart-3.jpg": 1070,
	"./depart-4.jpg": 9598,
	"./depart-5.jpg": 1690,
	"./depart-6.jpg": 3741,
	"./depart-7.jpg": 1047,
	"./depart-8.jpg": 4340,
	"./depart-9.jpg": 8393,
	"./depart-icon-1.png": 1833,
	"./depart-icon-11.png": 9512,
	"./depart-icon-2.png": 1872,
	"./depart-icon-3.png": 98,
	"./depart-icon-4.png": 6986,
	"./depart-icon-5.png": 1802,
	"./depart-icon-6.png": 5851,
	"./depart-icon-7.png": 9336,
	"./depart-icon-8.png": 6454,
	"./depart-icon-9.png": 7492,
	"./dna.jpg": 5259,
	"./doctor-single.jpg": 4847,
	"./epale.png": 8418,
	"./erasmus-logo.png": 4579,
	"./european-commission-logo.jpg": 1235,
	"./european-commission-logo.webp": 654,
	"./exhausted.jpg": 6212,
	"./facebook-cover-DARK-Recovered.png": 7264,
	"./feature-1.png": 6055,
	"./feature-2.png": 9649,
	"./feature-3.png": 2967,
	"./feature-4.png": 9417,
	"./food-literacy.webp": 8652,
	"./footer/footer-bg.png": 4304,
	"./gellary/01.jpg": 4410,
	"./gellary/02.jpg": 9472,
	"./gellary/03.jpg": 3921,
	"./gellary/04.jpg": 1552,
	"./gellary/05.jpg": 201,
	"./gellary/06.jpg": 4837,
	"./gellary/07.jpg": 4471,
	"./gellary/08.jpg": 4139,
	"./gellary/09.jpg": 3402,
	"./header-1.png": 2998,
	"./header-2.png": 9855,
	"./header-3.png": 9473,
	"./icons8-pediatrics-32.png": 5493,
	"./logo.png": 4427,
	"./logo2.png": 9842,
	"./major icons/Pharmaceutics.png": 9346,
	"./major icons/ams.png": 1483,
	"./major icons/baby.png": 730,
	"./major icons/brain.png": 5031,
	"./major icons/dna.png": 2669,
	"./major icons/genetics.png": 2482,
	"./major icons/heart.png": 7886,
	"./major icons/im.png": 8009,
	"./major icons/nutrition.png": 5606,
	"./major icons/syringe.png": 8792,
	"./major icons/tooth.png": 6683,
	"./major-icons/OIUGG40.jpg": 7701,
	"./message.jpg": 9482,
	"./mooc.png": 9147,
	"./objectives.jpg": 4085,
	"./packages-1.jpg": 6233,
	"./packages-2.jpg": 2167,
	"./packages-bg.jpg": 5189,
	"./pageheader.jpg": 4127,
	"./principles.jpeg": 6020,
	"./room.fbx": 9374,
	"./service-1.jpg": 2617,
	"./service-2.jpg": 7951,
	"./service-3.jpg": 2174,
	"./service-4.jpg": 4823,
	"./service-icon (1).png": 1440,
	"./service-icon (2).png": 3930,
	"./service-icon (3).png": 2975,
	"./service/05.jpg": 318,
	"./service/06.jpg": 9926,
	"./service/07.jpg": 9807,
	"./service/bg.jpg": 5602,
	"./service/icon/service-icon (10).png": 7412,
	"./service/icon/service-icon (4).png": 5533,
	"./service/icon/service-icon (5).png": 8698,
	"./service/icon/service-icon (6).png": 9519,
	"./service/icon/service-icon (7).png": 9987,
	"./service/icon/service-icon (8).png": 3409,
	"./service/icon/service-icon (9).png": 2307,
	"./service/service-single/01.jpg": 7975,
	"./service/service-single/doctor/01.png": 5956,
	"./service/service-single/doctor/02.png": 4321,
	"./service/service-single/doctor/03.png": 7628,
	"./service/service-single/doctor/04.png": 4884,
	"./services-1.jpeg": 4575,
	"./services-2.jpeg": 8772,
	"./services-3.jpeg": 2258,
	"./services-4.jpeg": 1478,
	"./services-5.jpeg": 6062,
	"./services-bg-blue.jpg": 2334,
	"./services-bg.jpg": 1301,
	"./services-bg2.jpg": 8124,
	"./shop (1).jpg": 1988,
	"./shop (10).jpg": 7165,
	"./shop (2).jpg": 8096,
	"./shop (3).jpg": 6767,
	"./shop (4).jpg": 9914,
	"./shop (5).jpg": 9632,
	"./shop (6).jpg": 2327,
	"./shop (7).jpg": 789,
	"./shop (8).jpg": 2921,
	"./shop (9).jpg": 3276,
	"./shop/desc.jpg": 970,
	"./shop/lest-p/01.jpg": 6951,
	"./shop/lest-p/02.jpg": 466,
	"./shop/lest-p/03.jpg": 7499,
	"./shop/lest-p/04.jpg": 7575,
	"./shop/shop (1).png": 2020,
	"./shop/shop (2).png": 629,
	"./shop/shop (3).png": 2113,
	"./shop/shop (4).png": 2299,
	"./sponsor (1).png": 9331,
	"./sponsor-1.png": 3849,
	"./sponsor-2.png": 8509,
	"./sponsor-3.png": 1475,
	"./sponsor-4.png": 9982,
	"./sponsor-5.png": 1996,
	"./sponsor-6.png": 5053,
	"./sponsor-7.png": 3827,
	"./sponsor-8.png": 4456,
	"./sponsor-9.png": 8864,
	"./team (6).jpg": 4773,
	"./team (7).jpg": 2924,
	"./team (8).jpg": 1117,
	"./team (9).jpg": 346,
	"./team-1.jpg": 5822,
	"./team-2.jpg": 6328,
	"./team-3.jpg": 4432,
	"./team-4.jpg": 3912,
	"./team/doctor-single/01.jpg": 6312,
	"./team/doctor-single/award/01.png": 5653,
	"./team/doctor-single/award/02.png": 9035,
	"./team/doctor-single/award/03.png": 1225,
	"./testimonial (1).png": 8313,
	"./testimonial (2).png": 1446,
	"./testimonial (3).png": 3736,
	"./testimonial-bg.jpg": 1305,
	"./testimonial/content/02.png": 6361,
	"./testimonial/content/03.png": 6811,
	"./uk-gov-logo.jpg": 2301,
	"./values.jpeg": 4683,
	"./vet.jpg": 9352,
	"./vip-logo.jpg": 5858,
	"./vip-logo.png": 9047,
	"./vision.jpg": 7782,
	"./who-we-are.jpeg": 7758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;